module.exports = __webpack_public_path__ + "SourceSansPro-ExtraLight.5238fb318ae505d32d48.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-ExtraLight.woff
// module id = ../../../../../src/assets/customfonts/SourceSansPro-ExtraLight.woff
// module chunks = styles